import $ from 'jquery'
import invariant from 'ts-invariant'

const debug = require('debug')('pm:mfa')

function notifySuccess(message: string) {
  $(document).trigger('postmark_mfa:notification:success', { message })
}

function showFormError($element: JQuery<HTMLElement>, message: string) {
  $(document).trigger('postmark_mfa:show-form-error', { $element, message })
}

$(function smsEditPage() {
  const $form = $('.js-2fa-form')
  if (!$form.length) return

  const $sendOtpButton = $('.js-2fa-send-code')
  const $country = $('.js-2fa-country')
  const $phoneNumberInput = $('.js-2fa-sms-input')
  const $phoneNumberHiddenInput = $('.js-2fa-sms-number')
  const $codeInput = $('.js-2fa-sms-sec-input')
  const $errorRow = $sendOtpButton.parents('.c-form-row')
  const sendOtpUrl = $sendOtpButton.data('url')

  if (typeof sendOtpUrl !== 'string') throw 'Missing url'

  let allowSendOtp = true

  const timeout = Number($sendOtpButton.data('timeout'))
  if (timeout > 0) {
    const nextSentAt = new Date()
    nextSentAt.setTime(nextSentAt.getTime() + timeout)

    allowSendOtp = false
    pauseOtpSending(nextSentAt, $sendOtpButton, () => (allowSendOtp = true))
  }

  $form.on('submit', event => {
    // Do not submit the form if user is focused on SMS number input
    // This is so we can send the security code instead of triggering the main form.
    if ($phoneNumberInput.is(':focus')) event.preventDefault()
  })

  $phoneNumberInput.each(function () {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const el = this

    import('./lazy-intl-tel').then(({ intlTelInput }) => {
      const iti = intlTelInput(el, {
        separateDialCode: true,
        initialCountry: String($country.val()) || 'US',
      })

      // Sync phone number from hidden input
      // If user refreshes page after sending security code
      const currentPhoneNumberValue = $phoneNumberHiddenInput.val() as string
      if (currentPhoneNumberValue.length) {
        iti.setNumber(currentPhoneNumberValue)
      }
    })
  })

  $phoneNumberInput.on('keypress', event => {
    // If user presses enter while typing in auth code
    if (event.keyCode === 13) $sendOtpButton.trigger('click')
  })

  $sendOtpButton.on('click', function sendOtp(event) {
    debug('sendOtp()')

    event.preventDefault()
    if (!allowSendOtp) return

    const phoneNumberInput = $phoneNumberInput.get(0)
    invariant(phoneNumberInput)
    const iti = window.intlTelInputGlobals.getInstance(phoneNumberInput)
    const number = iti.getNumber()
    const isValid = iti.isValidNumber()
    const countryData = iti.getSelectedCountryData()
    const unsupportedCountries = ['sg', 'ru']

    debug({ number, isValid })

    // Set hidden input
    // For sending the number to the server
    $phoneNumberHiddenInput.val(number)

    if (!isValid) {
      $phoneNumberInput.focus()
      showFormError($errorRow, 'Please enter a valid number.')
      return
    }

    if (unsupportedCountries.includes(countryData.iso2)) {
      showFormError(
        $errorRow,
        `We currently don't support SMS authentication in ${countryData.name}.`
      )
      return
    }

    // Clean up existing validation errors on the whole form
    $form
      .find('.c-form-row')
      .removeClass('error')
      .find('.c-form-row_error')
      .remove()

    // Show loading state
    $form.addClass('u-is-loading')

    sendOtpRequest(sendOtpUrl, { phone_number: number })
      .then(nextSendAt => {
        $codeInput.prop('disabled', false).focus()

        notifySuccess('We sent a security code to ' + number + '.')

        allowSendOtp = false
        pauseOtpSending(nextSendAt, $sendOtpButton, () => (allowSendOtp = true))
      })
      .catch(e => {
        showFormError($errorRow, e.message || e)
      })
      .finally(() => {
        $form
          .removeClass('u-is-loading')
          .find('input[type="submit"]')
          .prop('disabled', false)
      })
  })
})

$(function loginPage() {
  const phoneNumber = $('.js-2fa-number').text()
  const $resendOtpButton = $('.js-2fa-login-resend')
  const $errorRow = $('.js-2fa-login-code').parents('.c-form-row')
  const sendOtpUrl = $resendOtpButton.parents('form').attr('action')

  if (typeof sendOtpUrl !== 'string') return

  let allowSendOtp = true

  const timeout = Number($resendOtpButton.data('timeout'))
  if (timeout > 0) {
    const nextSentAt = new Date()
    nextSentAt.setTime(nextSentAt.getTime() + timeout)

    allowSendOtp = false
    pauseOtpSending(nextSentAt, $resendOtpButton, () => (allowSendOtp = true))
  }

  $resendOtpButton.on('click', function handleSendOtp(event) {
    debug('handleSendOtp()')
    event.preventDefault()
    if (!allowSendOtp) return

    const $form = $('form')

    $errorRow.removeClass('error').find('.c-form-row_error').remove()

    $form.addClass('u-is-loading')

    sendOtpRequest(sendOtpUrl, {})
      .then(nextSendAt => {
        notifySuccess('We sent a security code to ' + phoneNumber + '.')

        allowSendOtp = false
        pauseOtpSending(
          nextSendAt,
          $resendOtpButton,
          () => (allowSendOtp = true)
        )
      })
      .catch(e => {
        debug(e)
        showFormError($errorRow, e.message || e)
      })
      .finally(() => {
        $form
          .removeClass('u-is-loading')
          .find('input[type="submit"]')
          .prop('disabled', false)
      })
  })
})

$(function awaitPage() {
  const $el = $('.js-2fa-timeout')
  if (!$el.length) return

  const timeout = $el.data('timeout')

  if (timeout === undefined) {
    throw 'Missing timeout'
  }

  const $label = $('.js-2fa-timeout-label')

  if (timeout === 0) {
    // Forward the page right away if timeout is 0
    $label
      .parents('p')
      .text('Please wait while your security code is being sent.')
    $('form').submit()
    return
  }

  let count = timeout
  $label.text(count / 1000 + ' seconds')

  // Countdown every second
  const interval = setInterval(() => {
    count = count - 1000
    $label.text(count / 1000 + ' seconds')
  }, 1000)

  setTimeout(() => {
    clearInterval(interval)

    // Remove label
    $el.parents('fieldset').slideUp()

    $('form').submit()
  }, timeout)
})

$(function backupCodesWidget() {
  const $widget = $('.js-2fa-codes')
  if (!$widget.length) return

  $widget.find('.js-btn-copy-codes').each(function () {
    const $btn = $(this)

    $btn.on('click', () => {
      const $codes = $($btn.data('copy-target'))
      $codes.copyText()
    })
  })
})

$(function confirmCodesPage() {
  const $form = $('.js-2fa-confirm-codes-form')
  if (!$form.length) return

  const $btnSubmit = $form.find('.js-2fa-complete-setup-button')

  $form.on('change', '.js-2fa-cbx-confirmed', e => {
    const $confirmed = $(e.target)
    $btnSubmit.prop('disabled', !$confirmed.is(':checked'))
  })
})

function pauseOtpSending(
  until: Date,
  $button: JQuery<HTMLElement>,
  done: () => void
) {
  const timeout = until.getTime() - new Date().getTime()

  if (timeout < 0) {
    done()
    return
  }

  temporarilyDisableOtpSendingInUI($button, timeout, () => done())
}

interface OtpRequestPayload {
  phone_number?: string
}

interface SendOtpResult {
  success: true
  next_send_at: number
}

/**
 * @returns - timestamp when next sms can be sent
 */
function sendOtpRequest(
  url: string,
  payload: OtpRequestPayload
): Promise<Date> {
  debug(`sendOtpRequest('%s', '%j')`, url, payload)

  return new Promise((resolve, reject) => {
    $.ajax({
      method: 'POST',
      url,
      data: payload,
    })
      .done((response: SendOtpResult) => {
        resolve(new Date(response.next_send_at * 1000))
      })
      .fail(function (xhr) {
        const message = errorMessage(xhr)
        reject(new Error(message))
      })
  })

  function errorMessage(xhr: JQueryXHR): string {
    switch (xhr.status) {
      case 403:
        return (
          xhr?.responseJSON?.message ||
          'There was a problem sending the security code to your phone number. Please try again.'
        )
      case 429:
        return (
          xhr?.responseJSON?.message ||
          'Sorry! You’ve reached the maximum number of SMS messages per day.'
        )
      default:
        return 'There was a problem sending the security code to your phone number. Please try again.'
    }
  }
}

function temporarilyDisableOtpSendingInUI(
  $button: JQuery<HTMLElement>,
  timeout: number,
  callback: () => void
) {
  let count = timeout
  const labelPrefix = 'Resending is available in '

  // Show disabled state
  $button
    .addClass('is-disabled')
    .removeClass('is-hidden')
    .prop('disabled', true)

  const $label = $('<span />').addClass('two-fa-timeout-label')

  const updateLabel = () =>
    $label.text(labelPrefix + Math.floor(count / 1000) + ' seconds')

  updateLabel()

  $button.after($label)

  // Countdown every second
  const interval = setInterval(() => {
    count = count - 1000
    updateLabel()
  }, 1000)

  // When the timeout is over
  setTimeout(function () {
    clearInterval(interval)

    // Enable button
    $button.removeClass('is-disabled').prop('disabled', false)
    $label.remove()

    if (callback) callback()
  }, timeout)
}
